export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-33.4818c8cb.jpg";